// Thin os-core wrapper around the @os/learning web page. Routed from
// App.tsx at /workspace/learning.
import LearningIndexPage from '@os/learning/web/pages/LearningIndexPage'

export default function LearningWorkspacePage() {
  return <LearningIndexPage />
}
